import React from "react";
import { useIntl } from "react-intl";

import Seo from "../../../../common/helpers/seo";

import Hero from "./Hero";
import Choirs from "./Choirs";

import messages from "./messages";
import { StyledHome } from "./styles";

const Home = () => {
    const { formatMessage } = useIntl();
    return (
        <StyledHome marginTop={50} withShadow>
            <Seo
                title={`Musicators - ${formatMessage(messages.slogen)}`}
                description={formatMessage(messages.description)}
                app="choir"
            />
            <Hero />
            <Choirs />
        </StyledHome>
    );
};

export default Home;
